import React from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const LoadingScreen = () => {
  return (
    <div className="loading-screen" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <img 
              src="/sdg-logo/logo-horizontal.png" 
              alt="Kosovo SDG Logo" 
              style={{ 
                maxWidth: '300px', 
                marginBottom: '2rem' 
              }} 
            />
            <h3 style={{ color: '#1b3e51', marginBottom: '1rem' }}>
              Loading Sustainable Development Goals
            </h3>
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Fetching UN and EU goal data for Kosovo...
            </p>
            <Spinner 
              animation="border" 
              role="status" 
              style={{ color: '#039dda' }}
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoadingScreen;




